import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withHandlers,
  lifecycle,
  withState
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReactSelectMaterialUi from 'react-select-material-ui';
import GochiMenuDetailTableShop from '../../components/molecules/GochiMenuDetailTableShop';
import CloseButton from '../../components/atoms/CloseButton';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    padding: 10,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    paddingBottom: 10
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    padding: '5px 0 10px'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    detail,
    updateOpenDetailModal,
    isLanguage,
    setIsLanguage,
    isFukuoka
  }) => {
    let { menuName, promotionDescription, description } = detail;

    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData) {
        ({ menuName, description } = languageData.params);
        promotionDescription = languageData.params.quantityFreeDes;
      }
    }
    const closeAction = () => updateOpenDetailModal(false);
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleDetail}>
          {isFukuoka ? 'コース情報詳細' : 'メニュー情報詳細'}
        </Typography>
        <div>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
          <GochiMenuDetailTableShop
            menuName={menuName}
            menuChildType={detail.menuChildType}
            menuId={detail.menuId}
            price={detail.price}
            taxTypeStr={detail.taxTypeStr}
            reducedTaxTypeStr={detail.reducedTaxTypeStr}
            description={description}
            tags={detail.tags}
            comboMenu={detail.comboMenu}
            priceCombo={detail.priceCombo}
            quantityRelease={detail.quantityRelease}
            quantityPromotion={detail.quantityPromotion}
            promotionDescription={promotionDescription}
            usageLimit={detail.usageLimit}
            expiration={detail.expiration}
            expirationEndDate={detail.expirationEndDate}
            image={detail.image}
            subscription={detail.subscription}
            subscriptionIntervalCount={detail.subscriptionIntervalCount}
            subscriptionInterval={detail.subscriptionInterval}
            createdAt={detail.createdAt}
            updatedAt={detail.updatedAt}
            genreName={detail.menuGenreName}
            situationNames={detail.menuSituationNames}
            userTargetNames={detail.menuUserTargetNames}
            menuLimitTotal={detail.menuLimitTotal}
            isFukuoka={isFukuoka}
          />
        </div>
        <div>
          <CloseButton
            className={classes.btnClose}
            onClickAction={closeAction}
          />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
